// extracted by mini-css-extract-plugin
module.exports = {"button":"ShareUserButton_button__32de-"};